import { IHouse } from "../../interfaces/intarfaces";
import { calculateHousePrice } from "../../components/Chat/utils";
import { parseServerDate } from "../../utils/time";
import { IMarker } from "../../components/Map/GeoMap";

export enum SortDirectionEnum {
  PRICE_LOW_TO_HIGH = "low_to_high",
  PRICE_HIGH_TO_LOW = "high_to_low",
  NEWEST = "newest",
  FAVOURITES = "favourites"
}

export const HousesSortFunction: {
  [key: string]: (a: IHouse, b: IHouse) => number;
} = {
  [SortDirectionEnum.PRICE_LOW_TO_HIGH]: (a: IHouse, b: IHouse) => {
    return (calculateHousePrice(a) ?? 0) < (calculateHousePrice(b) ?? 0)
      ? -1
      : 1;
  },
  [SortDirectionEnum.PRICE_HIGH_TO_LOW]: (a: IHouse, b: IHouse) => {
    return (calculateHousePrice(a) ?? 0) < (calculateHousePrice(b) ?? 0)
      ? 1
      : -1;
  },
  [SortDirectionEnum.NEWEST]: (a: IHouse, b: IHouse) => {
    return parseServerDate(a.published_at!).getTime() <
      parseServerDate(b.published_at!).getTime()
      ? 1
      : -1;
  },
  [SortDirectionEnum.FAVOURITES]: (a: IHouse, b: IHouse) => {
    if (a.is_favorited && !b.is_favorited) {
      return -1;
    }
    if (!a.is_favorited && b.is_favorited) {
      return 1;
    }

    return (calculateHousePrice(a) ?? 0) < (calculateHousePrice(b) ?? 0)
      ? -1
      : 1;
  }
};

export const createMarkerForHouse = (
  house: IHouse,
  selected: boolean,
  active: boolean
): IMarker => {
  return {
    id: house.house_id!,
    position: { lat: house.latitude!, lng: house.longitude! },
    data: house,
    selected: selected,
    active: active,
    title: house.title
  };
};
